import React from 'react'

const NotFound = props => {
  return (
    <div style={ { width: '100%', textSize: '20px' } }>Not Found</div>
  )
}

export default NotFound
